import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Deed from '../components/Deed'

const DeedPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <Deed />
            </div>
          </main>
    )
}

export default DeedPage